export default "__VITE_ASSET__BtkkWZUm__"